import {Avatar, Tag} from "antd";


const ActivityTimeline = ({ history }) => {

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const months = [
            'January', 'February', 'March', 'April', 'May', 'June',
            'July', 'August', 'September', 'October', 'November', 'December'
        ];

        const month = months[date.getMonth()];
        const day = date.getDate();
        const year = date.getFullYear();

        let hours = date.getHours();
        const minutes = date.getMinutes();
        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;
        hours = hours ? hours : 12;
        const minutesStr = minutes < 10 ? '0' + minutes : minutes;

        return `${month} ${day}, ${year} at ${hours}:${minutesStr} ${ampm}`;
    };

    const getUserName = (email) => {
        if (!email) return 'System';
        return email.split('@')[0];
    };


    const groupedData = history.reduce((acc, item) => {
        const key = item.doc_hist_group_rank;
        if (!acc[key]) {
            acc[key] = [];
        }
        acc[key].push(item);
        return acc;
    }, {});

    const activities = Object.entries(groupedData).map(([groupRank, items]) => {
        const firstItem = items[0];

        return {
            groupRank: parseInt(groupRank),
            email: firstItem.actor_profile_email,
            timestamp: firstItem.created_at,
            msgType: firstItem.msg_type_title,
            changes: items.map(item => ({
                fieldTitle: item.field_title,
                userActionText: item.user_action_text,
                oldValueTitle: item.old_value_title,
                newValueTitle: item.new_value_title,
                targetEmail: item.target_profile_email,
                action: item.action
            }))
        };
    }).sort((a, b) => a.groupRank - b.groupRank);

    const renderChange = (change) => {
        const isAccessChange = change.fieldTitle === 'Access';

        if (isAccessChange) {
            return (
                <div className="change-content">
                    <Tag color="processing">{change.oldValueTitle || 'No access'}</Tag>
                    <svg className="arrow-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7l5 5m0 0l-5 5m5-5H6"></path>
                    </svg>
                    <Tag color="success">{change.newValueTitle}</Tag>
                </div>
            );
        }

        return (
            <div className="change-content">
                <Tag color="processing">{change.oldValueTitle || 'None'}</Tag>
                <svg className="arrow-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7l5 5m0 0l-5 5m5-5H6"></path>
                </svg>
                <Tag color="success" >{change.newValueTitle ? change.newValueTitle : "None"}</Tag>
            </div>
        );
    };

    return (
        <div className="timeline-container">
            <div className="activity-list">
                {activities.map((activity, index) => (
                    <div key={index} className="activity-item">
                        <Avatar
                            size="middle"
                            src={"https://api.dicebear.com/7.x/miniavs/svg?seed=3"}
                            style={{backgroundColor: "#3498ff", marginRight: 10}}
                        />

                        <div className="activity-content">
                            <div className="activity-header">
                                <span className="user-name">{getUserName(activity.email)}</span>
                                <span className="action-text"> {activity.msgType}</span>
                            </div>

                            <div className="timestamp">
                                <svg className="clock-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <circle cx="12" cy="12" r="10" strokeWidth="2"></circle>
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                                          d="M12 6v6l4 2"></path>
                                </svg>
                                <span>{formatDate(activity.timestamp)}</span>
                            </div>

                            <div className="changes-container">
                                {activity.changes.map((change, changeIndex) => (
                                    <div key={changeIndex} className="change-item">
                                        <div className="change-field-name">
                                            {change.userActionText} <strong>{change.fieldTitle}</strong>
                                            {change.targetEmail && (
                                                <span className="target-user"> for {getUserName(change.targetEmail)}</span>
                                            )}
                                        </div>
                                        <div className="change-box">
                                            {renderChange(change)}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ActivityTimeline;